<template>
  <div class="AboutGimmi">
    <section-header heading="2" ja="GIMMIについて"/>
    <normal-btn @click="onAboutGimmi01()">GIMMIの特徴について</normal-btn>
    <normal-btn @click="onAboutGimmi02()">プリクラについて</normal-btn>
    <normal-btn @click="onAboutGimmi03()">GIMMIの操作について</normal-btn>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '@/components/NormalBtn.vue'
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AppaboutGimmi",
  components: {
    SectionHeader,
    NormalBtn,
    SubBtn
  },
  methods: {
    onAboutGimmi01() {
      this.$router.push("/AppaboutGimmi01")
    },
    onAboutGimmi02() {
      this.$router.push("/AppaboutGimmi02")
    },
    onAboutGimmi03() {
      this.$router.push("/AppaboutGimmi03")
    },
    onBack() {
      this.$router.push("/Appfaq")
    }
  }
}
</script>

<style scoped>
</style>
